import * as io from 'io-ts';
import { nullableString } from '@shared/core/types/common';
import { defaultForEmptyOrderType, orderTypeIdsArray } from '@shared/core/types/consts';

const rootDefinition: io.MixedObject<OLO.Config.TopBar> = {
    orderTypeIds: orderTypeIdsArray,
    currentLocationOrderTypeText: io.union([nullableString, defaultForEmptyOrderType]),
};

export const topBarSchema = io.array(io.type(rootDefinition));
